import { MenuItem, Select } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Loading from "../../../Common/extra/loading";
import {
  editCustomer,
  getSubadminList,
  updateUser,
} from "../../../store/actions";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";

const AssignClient = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { editId } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    userId: "",
    FirstName: "",
    LastName: "",
    Email: "",
    Address: "",
    AptNo: "",
    City: "",
    State: "",
    Zip: "",
    document_template: "",
    CellPhone: "",
    WorkPhone: "",
    HomePhone: "",
    DOB: "",
    SSN: "",
    Marital_Status: "",
    TAX_RELIEF_TAX_AGENCY: "",
    Notes: "",
    Language: "",
    TAX_RELIEF_TAX_TYPE: "",
    SourceName: "",
    BusinessType: "",
    BusinessName: "",
    EIN: "",
    SMSPermit: true,
    TaxProblem: [],
    OpenerName: "",
    SETOfficerName: "",
    TaxPreparerName: "",
    DistributionId: "",
    StatusID: "",
    ProductID: "",
    UDF: "",
    profile_image: "",
    timezone: "",
    subadmins: [],
    archive: "0",
    pick_your_states: [],
  });
  console.log(data, "dfsttsstttst");
  const UserList = useSelector((s) => s?.Signatures?.subadmins?.data);
  const userData = useSelector((s) => s?.Customers?.edituser?.data);
  useEffect(() => {
    dispatch(getSubadminList());
  }, [dispatch]);

  useEffect(() => {
    if (editId) {
      dispatch(editCustomer(editId));
    }
  }, [editId]);

  useEffect(() => {
    if (userData?.amtaxsettlement_data) {
      setData((pre) => ({
        ...pre,
        userId: userData?.id || "",
        FirstName: userData?.amtaxsettlement_data?.FirstName || "",
        LastName: userData?.amtaxsettlement_data?.LastName || "",
        Email: userData?.amtaxsettlement_data?.Email || "",
        Address: userData?.amtaxsettlement_data?.Address || "",
        AptNo: userData?.amtaxsettlement_data?.AptNo || "",
        City: userData?.amtaxsettlement_data?.City || "",
        State: userData?.amtaxsettlement_data?.State || "",
        Zip: userData?.amtaxsettlement_data?.Zip || "",
        document_template: userData?.document_template || "",
        CellPhone:
          userData?.amtaxsettlement_data?.CellPhone?.replace(/[\D]/g, "") || "",
        WorkPhone:
          userData?.amtaxsettlement_data?.WorkPhone?.replace(/[\D]/g, "") || "",
        HomePhone:
          userData?.amtaxsettlement_data?.HomePhone?.replace(/[\D]/g, "") || "",
        DOB:
          moment(userData?.amtaxsettlement_data?.DOB).format("YYYY-MM-DD") ||
          "",
        SSN: userData?.amtaxsettlement_data?.SSN?.replace(/[\D]/g, "") || "",
        Marital_Status: userData?.amtaxsettlement_data?.Marital_Status || "",
        TAX_RELIEF_TAX_AGENCY:
          userData?.amtaxsettlement_data?.TAX_RELIEF_TAX_AGENCY || "",
        Notes: userData?.amtaxsettlement_data?.Notes || "",
        Language: userData?.amtaxsettlement_data?.Language || "",
        TAX_RELIEF_TAX_TYPE:
          userData?.amtaxsettlement_data?.TAX_RELIEF_TAX_TYPE || "",
        SourceName: userData?.amtaxsettlement_data?.SourceName || "",
        BusinessType: userData?.amtaxsettlement_data?.BusinessType || "",
        BusinessName: userData?.amtaxsettlement_data?.BusinessName || "",
        EIN: userData?.amtaxsettlement_data?.EIN || "",
        SMSPermit: userData?.amtaxsettlement_data?.SMSPermit || "",
        TaxProblem: userData?.amtaxsettlement_data?.TaxProblem || "",
        OpenerName: userData?.amtaxsettlement_data?.OpenerName || "",
        SETOfficerName: userData?.amtaxsettlement_data?.SETOfficerName || "",
        TaxPreparerName: userData?.amtaxsettlement_data?.TaxPreparerName || "",
        DistributionId: userData?.amtaxsettlement_data?.DistributionId || "",
        StatusID: userData?.amtaxsettlement_data?.StatusID || "",
        ProductID: userData?.amtaxsettlement_data?.ProductID || "",
        UDF: userData?.amtaxsettlement_data?.UDF || "",
        timezone: userData && userData["0"]?.timezone,
        archive: (userData && userData["0"]?.archive) || "0",
        profile_image: (userData && userData["0"]?.profile_image) || "",
        pick_your_states:
          (userData && JSON.parse(userData["0"]?.pick_your_states)) || [],
        subadmins:
          userData?.subadmins && userData?.subadmins.length > 0
            ? userData?.subadmins.map((itm) => itm.id)
            : [],
      }));
    }
  }, [userData]);

  const handleMultipleChange = (e) => {
    const { name, value } = e.target;
    setData((pre) => ({ ...pre, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    let body = {
      userId: data.userId,
      FirstName: data.FirstName,
      LastName: data.LastName,
      Email: data.Email,
      Address: data.Address,
      AptNo: data.AptNo,
      City: data.City,
      State: data.State,
      Zip: data.Zip,
      document_template: data.document_template,
      CellPhone: data.CellPhone ? "+" + data.CellPhone : "",
      WorkPhone: data.WorkPhone ? "+" + data.WorkPhone : "",
      HomePhone: data.HomePhone ? "+" + data.HomePhone : "",
      DOB:
        moment(data.DOB).format("MM/DD/YYYY") === "Invalid date"
          ? ""
          : moment(data.DOB).format("MM/DD/YYYY"),
      SSN: data.SSN,
      Marital_Status: data.Marital_Status,
      TAX_RELIEF_TAX_AGENCY: data.TAX_RELIEF_TAX_AGENCY,
      Notes: data.Notes,
      Language: data.Language,
      TAX_RELIEF_TAX_TYPE: data.TAX_RELIEF_TAX_TYPE,
      SourceName: data.SourceName,
      SMSPermit: data.SMSPermit,
      TaxProblem: data.TaxProblem,
      OpenerName: data.OpenerName,
      SETOfficerName: data.SETOfficerName,
      TaxPreparerName: data.TaxPreparerName,
      DistributionId: data.DistributionId,
      StatusID: data.StatusID,
      ProductID: data.ProductID,
      UDF: data.UDF,
      timezone: data.timezone,
      profile_image: data.profile_image,
      subadmins: JSON.stringify(data.subadmins),
      status: "active",
      archive: data.archive,
      pick_your_states: data.pick_your_states,
    };

    let businessBody = {
      BusinessType: data.BusinessType,
      BusinessName: data.BusinessName,
      EIN: data.EIN,
    };

    let finalBody;
    if (
      data.TAX_RELIEF_TAX_TYPE == "Personal and Business" ||
      data.TAX_RELIEF_TAX_TYPE == "Business"
    ) {
      finalBody = { ...body, ...businessBody };
    } else {
      finalBody = { ...body };
    }

    const callback = (res) => {
      setLoading(false);
      if (res.data) {
        toast.success("User Updated Successfully");
        setTimeout(() => {
          navigate("/customers");
        }, 500);
      }
    };
    dispatch(updateUser(finalBody, callback));
  };

  return (
    <>
      {loading && <Loading className={"cstmLoader"} />}
      <Container>
        <Row className="mt-4">
          <Col lg="10">
            <Row>
              <Col lg="6">
                <label htmlFor="" className="form-label2 m-0">
                  Client's Email
                </label>
                <input
                  type="text"
                  name="email"
                  value={data?.Email}
                  className="form-control"
                  disabled
                />
              </Col>
              <Col lg="6" className="my-2 doc-select">
                <label htmlFor="" className="form-label2 m-0">
                  Assign Client to the Team
                </label>
                <Select
                  className="demo-simple-select-label mt-2"
                  id="demo-simple-select"
                  multiple
                  name="subadmins"
                  value={data.subadmins}
                  onChange={handleMultipleChange}
                  MenuProps={(UserList && UserList) || []}
                >
                  {UserList &&
                    UserList.length > 0 &&
                    UserList.map((item, idx) => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name + " " + item.last_name}
                        </MenuItem>
                      );
                    })}
                </Select>
              </Col>
              <Col lg="12" className="my-2">
                <div className="pt-4 btn-wrp d-flex algign-items-center">
                  <Button
                    className="d-flex align-items-center justify-content-center me-2"
                    onClick={handleSubmit}
                  >
                    Submit
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AssignClient;
